(function() {
  // Configuration
  const MX_DOMAIN = 'mx.baroccowholesale.com';
  const API_KEY = 'e866bb3408dd4ecb90c49b4d23d70521';
  const COOKIE_NAME = 'geo_redirect_checked';
  const COOKIE_DAYS = 1; // Check once per day
  const DEBUG = true; // Set to false to disable debug logs
  
  // Debug logger
  function log(message, data) {
    if (DEBUG) {
      console.log(`[GEO-REDIRECT] ${message}`, data || '');
    }
  }
  
  log('Script initialized');
  log('Current hostname:', window.location.hostname);
  log('Current full URL:', window.location.href);
  
  // Check if we've already done the redirect check recently
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    const domain = window.location.hostname.replace('www.', '');
    const cookieString = `${name}=${value};${expires};path=/;domain=${domain}`;
    document.cookie = cookieString;
    log('Cookie set:', cookieString);
  }
  
  // Skip if we're already on the MX domain
  if (window.location.hostname.includes(MX_DOMAIN)) {
    log('Already on MX domain - skipping redirect');
    setCookie(COOKIE_NAME, 'mx', COOKIE_DAYS);
    return;
  }
  
  // Check for existing cookie
  const existingCookie = getCookie(COOKIE_NAME);
  log('Existing cookie value:', existingCookie);
  
  // Only skip if we've already checked AND we're on the main domain (not MX)
  // This means: if cookie says 'main', user was already determined to NOT be from Mexico
  if (existingCookie === 'main') {
    log('Cookie found - user already confirmed NOT from Mexico - skipping check');
    return;
  }
  
  log('Starting geolocation API call...');
  
  // Detect user location and redirect if needed
  fetch(`https://api.geoapify.com/v1/ipinfo?&apiKey=${API_KEY}`)
    .then(response => {
      log('API response status:', response.status);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(result => {
      log('API response received:', result);
      
      // Check if user is from Mexico
      if (result.country && result.country.iso_code === 'MX') {
        log('User detected from Mexico - preparing redirect');
        
        // Construct the redirect URL preserving the path and query string
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search;
        const currentHash = window.location.hash;
        
        // Build the new URL
        const redirectUrl = `https://${MX_DOMAIN}${currentPath}${currentSearch}${currentHash}`;
        
        log('Redirecting to:', redirectUrl);
        
        // Redirect to MX domain
        window.location.replace(redirectUrl);
      } else {
        log('User not from Mexico. Country code:', result.country?.iso_code || 'Unknown');
        // Set cookie ONLY if user is NOT from Mexico to avoid repeated checks
        setCookie(COOKIE_NAME, 'main', COOKIE_DAYS);
      }
    })
    .catch(error => {
      log('ERROR occurred:', error);
      console.error('[GEO-REDIRECT] Geo-detection error:', error);
      console.error('[GEO-REDIRECT] Error details:', {
        message: error.message,
        stack: error.stack
      });
      // Set cookie on error ONLY to avoid repeated failed API calls
      setCookie(COOKIE_NAME, 'error', COOKIE_DAYS);
    });
})();